
export function convertPxToRem(html) {
    const rootValue = 16; // 必须与 postcss-px2rem 的 rootValue 一致
    return html.replace(/(\d+)px/g, (match, px) => {
        return `${px / rootValue}rem`;
    });
}


// WEBPACK FOOTER //
// ./src/utils/utils.js